import { getApiErrorMessage } from 'helper/getApiErrorMessage';
import { addNotification } from 'helper/notifications';

export const notifyApiError = (error) => {
  addNotification(getApiErrorMessage(error));
};

export const runWithApiErrorNotification = async (action) => {
  try {
    return await action();
  } catch (error) {
    notifyApiError(error);

    throw error;
  }
};
